import { getSessionStorageItem, removeSessionStorageItem, setSessionStorageItem } from '@ui-common/utils/storage'
import { useEffect, useState } from 'react'

export const AUTHENTICATED_AT = 'a11at'

interface UseSessionTimerReturnType {
  shouldShowTimeoutModal: boolean
  shouldLogout: boolean
}

export const useSessionTimer = (
  isLoggedIn: boolean,
  showTimeoutModalInMs: number,
  logoutInMs: number,
): UseSessionTimerReturnType => {
  const [shouldShowTimeoutModal, setShouldShowTimeoutModal] = useState(false)
  const [shouldLogout, setShouldLogout] = useState(false)

  useEffect(() => {
    let timeout: ReturnType<typeof setTimeout>
    if (isLoggedIn) {
      let authAt = getSessionStorageItem(AUTHENTICATED_AT)
      if (!authAt) {
        const now = `${Date.now()}`
        setSessionStorageItem(AUTHENTICATED_AT, now)
        authAt = now
      }
      const delay = showTimeoutModalInMs - (Date.now() - Number(authAt))
      timeout = setTimeout(() => {
        setShouldShowTimeoutModal(true)
      }, delay)
    } else {
      removeSessionStorageItem(AUTHENTICATED_AT)
      setShouldShowTimeoutModal(false)
    }

    return () => clearTimeout(timeout)
  }, [isLoggedIn, showTimeoutModalInMs])

  useEffect(() => {
    let timeout: ReturnType<typeof setTimeout>
    if (isLoggedIn) {
      const authAt = getSessionStorageItem(AUTHENTICATED_AT)
      if (!authAt) {
        setShouldLogout(true)
      }
      const delay = logoutInMs - (Date.now() - Number(authAt))
      timeout = setTimeout(() => {
        setShouldLogout(true)
      }, delay)
    }
    return () => clearTimeout(timeout)
  }, [isLoggedIn, logoutInMs])

  return { shouldShowTimeoutModal, shouldLogout }
}
